import React, {useEffect, useState} from "react";
import {Route, Switch, useHistory} from "react-router-dom";
import {Button, Typography} from "@mui/material";
import StaffDashboard from "./Pages/Staff/StaffDashboard/StaffDashboard";
import Campaigns from "./Pages/Staff/Campaigns/Campaigns";
import StaffVets from "./Pages/Staff/StaffVets/StaffVets";
import StaffVouchers from "./Pages/Staff/StaffVouchers/StaffVouchers";
import StaffInvoices from "./Pages/Staff/StaffInvoices/StaffInvoices";
import StaffSponsorCodes from "./Pages/Staff/StaffSponsors/StaffSponsorCodes";
import StaffNZCAR from "./Pages/Staff/StaffNZCAR/StaffNZCAR";
import FunctionsData from "./Functions/FunctionsData";
import NotFound from "./Pages/NotFound";
import './App.css';
import StaffVetRegistrations from "./Pages/Staff/StaffVetRegistrations/StaffVetRegistrations";
import FinanceSuccess from "./Pages/FinanceSuccess";
import {AuthenticatedTemplate, UnauthenticatedTemplate, useMsal} from "@azure/msal-react";
import moment from "moment";
import StaffMicrochips from "./Pages/Staff/StaffMicrochips/StaffMicrochips";

function App() {
	return (
		<>
			<AuthenticatedTemplate>
				<AppSourceAuthenticated/>
			</AuthenticatedTemplate>

			<UnauthenticatedTemplate>
				<Typography variant="h6">
					<center>Please sign-in to see your profile information.</center>
				</Typography>
			</UnauthenticatedTemplate>
		</>
	)
}

function AppSourceAuthenticated() {

	const { instance,accounts } = useMsal();
	// console.log({instance}, {accounts});

	let history = useHistory();
	const stk = sessionStorage.sTkn;
	const [valid, setValid] = React.useState(false);
	const [current, setCurrent] = useState(window.location.pathname ?? '/');
	const [loading, setLoading] = useState(true);
	const [err, setErr] = useState('');
	const name = accounts[0] && accounts[0].name;

	useEffect(() => {
		console.log(stk);
		if (stk === null || stk === '') {
			createToken();
		} else {
			verify(stk);
		}
	}, [loading])

	function verify(tkn) {
		fetch(FunctionsData.getApiUrl('/api/search/a1/verify'),
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({'tkn': tkn})
			})
			.then(res => res.json())
			.then((r) => {
				if (r.data) {
					setValid(true);
				}else{
					createToken();
				}
				setLoading(false);
			});
	}

	function linkMe(e, target) {
		e.preventDefault();
		setCurrent(target);
		history.push(target);
	}

	if (loading === true) return null;

	function createToken() {
		// <StaffLogin setValid={setValid}/>

		let postVars = {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({
				email: name

			})
		};

		fetch(FunctionsData.getApiUrl("/api/search/authenticate/staff"), postVars)
			.then(response => response.json())
			.then((res) => {
				console.log(res)
					try {
						if (res.valid > 0) {
							//console.log('/api/authenticate/staff/', res)
							sessionStorage.setItem("sTkn", res.token);
							window.gtag('event', 'action', {
								category: 'Staff',
								action: 'Staff login'
							});
							setValid(true);
							window.location.href ='/';
						} else {
							setErr('Username / password combination is invalid.');
							window.gtag('event', 'action', {
								category: 'Staff',
								action: 'Staff login failure'
							});
							window.location.href ='/';
						}
					} catch (e) {
						setErr('Username / password combination is invalid.');
						window.gtag('event', 'action', {
							category: 'Staff',
							action: 'Staff login failure'
						});
						window.location.href ='/';
					}


				}
			)
	}

	function handleLogout(instance) {
		instance.logoutRedirect()
			.then((r) => {
				sessionStorage.clear();
			})
			.catch(e => {
			console.error(e);
		});
	}


	if (valid === true) return (

		<div className="App" style={{padding: 20}}>
			<h1 style={{padding: 20, margin: '20px 0'}}>
				SPCA Desexing Campaign - Campaign Management
				<Button sx={{marginLeft: 2}} variant={"contained"} onClick={() => {
					handleLogout(instance)
				}}>Log out</Button>
				<br />
				<div style={{fontSize:14,margin:0}}>
					{(moment().format("HH") <= 12) ? <p>Good morning, {name}</p> : null}
					{(moment().format("HH") >12 && moment().format("HH") < 14) ? <p>Good day, {name}</p> : null}
					{(moment().format("HH") >= 14) ? <p>Good afternoon, {name}</p> : null}
				</div>
			</h1>

			<div className={"menu"}>
				<div className={(current === '/') ? 'active' : ''} onClick={(e) => linkMe(e, '/')}>
					<a href="#" onClick={(e) => linkMe(e, '/')}>Dashboard</a>
				</div>
				<div className={(current === '/registrations') ? 'active' : ''}
				     onClick={(e) => linkMe(e, '/registrations')}>
					<a href="#" onClick={(e) => linkMe(e, '/registrations')}>Vet registrations</a>
				</div>
				<div className={(current === '/vets') ? 'active' : ''} onClick={(e) => linkMe(e, '/vets')}>
					<a href="#" onClick={(e) => linkMe(e, '/vets')}>Participating Vets</a>
				</div>
				<div className={(current === '/campaigns') ? 'active' : ''}
				     onClick={(e) => linkMe(e, '/campaigns')}>
					<a href="#" onClick={(e) => linkMe(e, '/campaigns')}>Snip 'n' Chip</a>
				</div>
				<div className={(current === '/campaigns-community') ? 'active' : ''}
				     onClick={(e) => linkMe(e, '/campaigns-community')}>
					<a href="#" onClick={(e) => linkMe(e, '/campaigns-community')}>Centre Campaigns</a>
				</div>
			
				<div className={(current === '/campaigns-inspectors') ? 'active' : ''}
				     onClick={(e) => linkMe(e, '/campaigns-inspectors')}>
					<a href="#" onClick={(e) => linkMe(e, '/campaigns-community')}>Inspectors Campaigns</a>
				</div>	
				<div className={(current === '/campaigns-outreach') ? 'active' : ''}
				     onClick={(e) => linkMe(e, '/campaigns-outreach')}>
					<a href="#" onClick={(e) => linkMe(e, '/campaigns-outreach')}>Outreach Campaigns</a>
				</div>			
				<div className={(current === '/sponsors') ? 'active' : ''} onClick={(e) => linkMe(e, '/sponsors')}>
					<a href="#" onClick={(e) => linkMe(e, '/sponsors')}>Sponsor program</a>
				</div>
				<div className={(current === '/vouchers') ? 'active' : ''} onClick={(e) => linkMe(e, '/vouchers')}>
					<a href="#" onClick={(e) => linkMe(e, '/vouchers')}>All vouchers</a>
				</div>
				<div className={(current === '/unusedvouchers') ? 'active' : ''} onClick={(e) => linkMe(e, '/unusedvouchers')}>
					<a href="#" onClick={(e) => linkMe(e, '/unusedvouchers')}>Unused vouchers</a>
				</div>
				<div className={(current === '/schedules') ? 'active' : ''}
				     onClick={(e) => linkMe(e, '/schedules')}>
					<a href="#" onClick={(e) => linkMe(e, '/schedules')}>To be invoiced</a>
				</div>
				<div className={(current === '/nzcar') ? 'active' : ''} onClick={(e) => linkMe(e, '/nzcar')}>
					<a href="#" onClick={(e) => linkMe(e, '/nzcar')}>NZCAR</a>
				</div>
                <div className={(current === '/microchips') ? 'active' : ''} onClick={(e) => linkMe(e, '/microchips')}>
                    <a href="#" onClick={(e) => linkMe(e, '/microchips')}>Microchips</a>
                </div>
			</div>
			<div>
				<Switch>
					<Route exact path="/nzcar">
						<StaffNZCAR/>
					</Route>
					<Route exact path="/campaigns">
						<Campaigns key={"c1"} />
					</Route>
					<Route exact path="/campaigns-community">
						<Campaigns key={"c2"} community />
					</Route>
					<Route exact path="/campaigns-outreach">
						<Campaigns key={"c4"} outreach />
					</Route>
					<Route exact path="/campaigns-inspectors">
						<Campaigns key={"c3"} inspectors />
					</Route>
					<Route exact path="/vets">
						<StaffVets/>
					</Route>
					<Route exact path="/vouchers">
						<StaffVouchers version={"all"}/>
					</Route>
					<Route exact path="/unusedvouchers">
						<StaffVouchers version={"unused"}/>
					</Route>
					<Route exact path="/schedules">
						<StaffInvoices/>
					</Route>
                    <Route exact path="/microchips">
                        <StaffMicrochips/>
                    </Route>
					<Route exact path="/sponsors">
						<StaffSponsorCodes/>
					</Route>
					<Route exact path="/registrations">
						<StaffVetRegistrations/>
					</Route>
					<Route exact path="/finance">
						<FinanceSuccess/>
					</Route>
					<Route exact path="/">
						<StaffDashboard setCurrent={setCurrent}/>
					</Route>
					<Route path="*">
						<NotFound/>
					</Route>
				</Switch>
			</div>
		</div>
	)

}

export default App;
